import { render, staticRenderFns } from "./routers.vue?vue&type=template&id=7fba85f6&scoped=true&"
import script from "./routers.vue?vue&type=script&lang=js&"
export * from "./routers.vue?vue&type=script&lang=js&"
import style0 from "./routers.vue?vue&type=style&index=0&id=7fba85f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba85f6",
  null
  
)

export default component.exports